import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICON } from '@core/util/icon';
import {
	StewartModalComponent,
	StewartModalData,
} from '../../stewart-modal/stewart-modal.component';
import { take } from 'rxjs/operators';
import {
	StewartCancelModalComponent,
	StewartCancelModalData,
} from '../cancel-modal/cancel-modal.component';
import { MatterDispatch } from '@state/matter';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { StewartStatus } from '@models/title-insurance/stewart';
import { BlankTitleInsurance } from '../../../chicago/chicago.component';
import { TestHooks } from './footer.hooks';

@Component({
	selector: 'app-stewart-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss'],
	standalone: false,
})
export class StewartFooterComponent {
	testHooks = TestHooks;
	public blankTitleInsurance = BlankTitleInsurance;
	public ICON = ICON;
	@Input() status: number;
	@Input() allowCancel = true;

	@SelectSnapshot(SelectedMatter.id) matterId: string;

	constructor(
		private dialog: MatDialog,
		private matterDispatch: MatterDispatch,
	) {}

	cancel(): void {
		const data: StewartCancelModalData = {
			status: this.status,
		};

		const modalRef = this.dialog.open(StewartCancelModalComponent, {
			data,
			maxWidth: '450px',
			width: '90%',
		});

		modalRef
			.afterClosed()
			.pipe(take(1))
			.subscribe((value) => {
				if (value) {
					if (!this.status || this.status === StewartStatus.NOT_SUBMITTED) {
						this.matterDispatch.SetTitleInsurance(
							this.matterId,
							this.blankTitleInsurance,
						);
					} else {
						this.dialog.open(StewartModalComponent);
					}
				}
			});
	}
}
